import React, { useState, useEffect } from 'react';
import { firestore } from './firebase';
import { collection, getDocs } from 'firebase/firestore';
import { Pie } from 'react-chartjs-2';
import 'chart.js/auto';

const LandingPage = () => {
  const [chartData, setChartData] = useState(null);
  const [statusChartData, setStatusChartData] = useState(null);

  useEffect(() => {
    const fetchWaitlistData = async () => {
      try {
        const querySnapshot = await getDocs(collection(firestore, 'students'));
        const classCounts = {
          Cubs: 0,
          Teddies: 0,
          Koalas: 0,
          Pandas: 0,
          Preschool: 0,
          PreK: 0,
          Kindergarten: 0,
        };

        const statusCounts = {
          Main: 0,
          Starting: 0,
          'Future / Incoming': 0,
          Declined: 0,
          Archived: 0,
          Enrolled: 0,
          'Too Old': 0,
        };

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          if (data.children && data.children[0]) {
            const childBirthday = data.children[0].dateOfBirth.toDate();
            const age = calculateAge(childBirthday);
            const childClass = getClassBasedOnAge(age);
            classCounts[childClass]++;
          }
          if (data.enquiry && data.enquiry.whichWaitlist) {
            const waitlistName = data.enquiry.whichWaitlist;
            if (waitlistName === 'Future' || waitlistName === 'Incoming') {
              statusCounts['Future / Incoming']++;
            } else if (Object.prototype.hasOwnProperty.call(statusCounts, waitlistName)) {
              statusCounts[waitlistName]++;
            }
          }
        });

        const classDistributionData = {
          labels: Object.keys(classCounts),
          datasets: [
            {
              label: 'Class Distribution',
              data: Object.values(classCounts),
              backgroundColor: [
                '#FF6384',
                '#36A2EB',
                '#FFCE56',
                '#4BC0C0',
                '#9966FF',
                '#FF9F40',
                '#FFCD56',
              ],
            },
          ],
        };

        const statusDistributionData = {
          labels: Object.keys(statusCounts),
          datasets: [
            {
              label: 'Status Distribution',
              data: Object.values(statusCounts),
              backgroundColor: [
                '#FF6384',
                '#36A2EB',
                '#FFCE56',
                '#4BC0C0',
                '#9966FF',
                '#FF9F40',
                '#6EE7B7',
              ],
            },
          ],
        };

        setChartData(classDistributionData);
        setStatusChartData(statusDistributionData);
      } catch (error) {
        console.error('Error fetching waitlist data: ', error);
      }
    };

    fetchWaitlistData();
  }, []);

  const calculateAge = (dateOfBirth) => {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
    }

    return age + (monthDiff / 12) + (dayDiff / 365.25);
  };

  const getClassBasedOnAge = (age) => {
    switch (true) {
        case (age >= 0 && age < (8 / 52)): // 0 to 8 weeks
            return "Newborns"; // Added a class for clarity
        case (age >= (8 / 52) && age < 1): // 8 weeks to <12 months
            return "Cubs";
        case (age >= 1 && age < 1.5): // 12 to <18 months
            return "Teddies";
        case (age >= 1.5 && age < 2): // 18 to <24 months
            return "Koalas";
        case (age >= 2 && age < 3): // 2 to <3 years
            return "Pandas";
        case (age >= 3 && age < 4): // 3 to <4 years
            return "Preschool";
        case (age >= 4 && age < 5): // 4 to <5 years
            return "Pre-K";
        case (age >= 5): // 5 years and older
            return "Kindergarten";
        default:
            return "Unknown"; // Added a default case for safety
    }
  };

  return (
    <div className="flex flex-col items-center justify-center bg-white-100">
      {/* Centered Image */}
      <div className="flex items-center justify-center mb-4">
        <img
          src="/logo.jpeg"
          alt="Teddy's Ladder logo"
          className="w-64 h-64 object-contain"
        />
      </div>

      <div className="flex justify-center space-x-8 w-full max-w-screen-lg mt-20">
        
        {/* Class Distribution Chart */}
        {chartData && (
          <div className="w-1/2">
            <Pie
              data={chartData}
              options={{
                plugins: {
                  legend: {
                    position: 'bottom',
                  },
                },
              }}
            />
          </div>
        )}

        {/* Status Distribution Chart */}
        {statusChartData && (
          <div className="w-1/2">
            <Pie
              data={statusChartData}
              options={{
                plugins: {
                  legend: {
                    position: 'bottom',
                  },
                },
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default LandingPage;
